import { render, staticRenderFns } from "./scollList.vue?vue&type=template&id=11072f50&scoped=true"
import script from "./scollList.vue?vue&type=script&lang=js"
export * from "./scollList.vue?vue&type=script&lang=js"
import style0 from "./scollList.vue?vue&type=style&index=0&id=11072f50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11072f50",
  null
  
)

export default component.exports